"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFeatureFlag = void 0;
var useFeatureFlag_1 = require("./useFeatureFlag");
Object.defineProperty(exports, "useFeatureFlag", { enumerable: true, get: function () { return useFeatureFlag_1.useFeatureFlag; } });
